import { render, staticRenderFns } from "./ProductListChipView.vue?vue&type=template&id=14405e36"
import script from "./ProductListChipView.vue?vue&type=script&lang=js"
export * from "./ProductListChipView.vue?vue&type=script&lang=js"
import style0 from "./ProductListChipView.vue?vue&type=style&index=0&id=14405e36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports